<div class="dropdown-card"> 
    <ng-content></ng-content>
</div>
